import ResourceFooter from "../../../../src/components/resourceFooter.mdx";
import { FORMID_CUSTOMER_DATA } from "gatsby-env-variables";
import * as React from 'react';
export default {
  ResourceFooter,
  FORMID_CUSTOMER_DATA,
  React
};